declare const __APP_CONFIG__: {
  ENV: string;
  API_BASE_URL: string;
  SUPPORT_EMAIL: string;
};

export const environment = {
  APP_NAME: 'settlement' as const,
  PRODUCTION: __APP_CONFIG__.ENV === 'production',
  API_BASE_URL: __APP_CONFIG__.API_BASE_URL || 'https://dev.olvpay.api.silicondali.com',
  SUPPORT_EMAIL: __APP_CONFIG__.SUPPORT_EMAIL || 'support@example.com',
};
